import React, { useState, useEffect } from 'react';
import { X, Send } from 'lucide-react';
import axios from 'axios';
import { CONFIG } from '../utils/config';
import './WhatsAppModal.css';

const WhatsAppModal = ({ isOpen, onClose, initialMessage }) => {
  const [whatsappNumber, setWhatsappNumber] = useState('237676339620');
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    axios.get(`${CONFIG.API_BASE}/settings`).then(res => {
      if (res.data.contact_whatsapp) setWhatsappNumber(res.data.contact_whatsapp);
    }).catch(() => {});
    
    const now = new Date();
    setCurrentTime(now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
  }, []);

  const defaultMessage = `👋 Welcome to Zaptopay!

Your trusted partner for secure Crypto-to-XAF exchange. 🔒

📊 TODAY'S LIVE RATES (USDT)
🟢 YOU SELL to us: 573 XAF/$
🔴 YOU BUY from us: 598 XAF/$

💡 HOW TO START:
Tell us what you need in one quick message. 
For example: "I want to sell $100 USDT" or "I want to buy $50 of BTC."

⏱️ A real, verified Zaptopay agent is standing by to process your transaction safely in under 2 minutes.

How can we help you today? 👇`;

  const [message, setMessage] = useState(initialMessage || defaultMessage);

  useEffect(() => {
    if (isOpen && initialMessage) {
      setMessage(initialMessage);
    }
  }, [isOpen, initialMessage]);

  const handleSend = () => {
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${whatsappNumber}?text=${encodedMessage}`, '_blank');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="whatsapp-modal-overlay" onClick={onClose}>
      <div className="whatsapp-modal" onClick={(e) => e.stopPropagation()}>
        
        {/* WhatsApp Header */}
        <div className="modal-header">
          <div className="header-left">
            <div className="agent-avatar">
              <img src="/assets/logos/logo-navbar.png" alt="Zaptopay Agent"  loading="lazy" />
              <div className="online-indicator"></div>
            </div>
            <div>
              <h3>Zaptopay Trade Desk</h3>
              <p className="agent-status">online</p>
            </div>
          </div>
          <button className="close-btn" onClick={onClose} aria-label="Close">
            <X size={20} />
          </button>
        </div>

        {/* WhatsApp Chat Body */}
        <div className="modal-body">
          {/* Zaptopay Welcome Message (Incoming) */}
          <div className="chat-bubble incoming">
            <div className="chat-content">
              👋 Hello! Welcome to Zaptopay Trade Desk. I am your verified trade agent. How can I help you today?
            </div>
            <div className="chat-bubble-footer">
              <span className="chat-time">{currentTime}</span>
            </div>
          </div>

          {/* User trade request message preview (Outgoing) */}
          <div className="chat-bubble outgoing">
            <div className="chat-content">
              {message}
            </div>
            <div className="chat-bubble-footer">
              <span className="chat-time">{currentTime}</span>
              <span className="chat-status">
                <svg viewBox="0 0 16 11" width="16" height="11" fill="currentColor">
                  <path d="M11.832 1.646a.5.5 0 0 1 .707 0l3 3a.5.5 0 0 1-.708.708L12.5 3.031l-3.328 3.328a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 .708-.708l2.646 2.647 3.328-3.328a.5.5 0 0 1 0-.708zM15 8.5v1.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6.5a.5.5 0 0 1 0 1H2v8h12V8.5a.5.5 0 0 1 1 0z"></path>
                </svg>
              </span>
            </div>
          </div>
        </div>

        {/* WhatsApp Footer / Input Area */}
        <div className="modal-footer">
          <button className="send-btn" onClick={handleSend}>
            <Send size={18} fill="currentColor" />
            Send to WhatsApp
          </button>
        </div>
        
      </div>
    </div>
  );
};

export default WhatsAppModal;